module.exports = __webpack_public_path__ + "static/media/USA.c5dbb476.jpg";